import validate from 'validate.js';
import parsePhoneNumber from 'libphonenumber-js/mobile';

// return only the first error message
validate.formatters.firstError = function(errors) {
    var errObj = {};
    if (errors.length > 0) {
        for (let i=0; i<errors.length; i++) {
            let field = errors[i].attribute;
            let msg = errors[i].options.message;
            errObj[field] = msg;
        }
    }
    return errObj;
};

validate.validators.truthy = function(value, options, key, attributes) {
    if (!value) {
        return options.message || "This field is required";
    }
    return;
}

// validate required fields that appear conditionally in the DealerContactModule component
validate.validators.dealerContactRequired = function(value, options, key, attributes) {
    if ((typeof attributes.dealerContact === 'undefined' || attributes.dealerContact === true) && (!value || value === null || value === "")) {
        return options.message || "This field is required";
    }
    return;
};

validate.validators.tradeinRequired = function(value, options, key, attributes) {
    if (attributes.tradeIn && attributes.tradeIn === 'true' && (!value || value === null || value === "")) {
        return options.message || "This field is required";
    }
    return;
}

validate.validators.isVin = function(value, options, key, attributes) {
    if (!value || value === "") { return; }
    var vin = value.toUpperCase();
    if(vin.length !== 17) {
        return options.message || "Please enter a valid VIN";
    }
    // begin WAU, WUA, TRU,
    if(! /^(WAU|WUA|TRU)/.test(vin) ) {
        return options.message || "Please enter a valid VIN";
    }
    // followed by ZZZ
    if(! /^...(ZZZ)/.test(vin) ) {
        return options.message || "Please enter a valid VIN";
    }
    return;
};

validate.validators.isPhoneNumber = function(value, options, key, attributes) {
    if(!value || value.length < 2) {
        return options.message || "Please enter a valid phone number";
    }
    try {
        let countryCode = attributes.country ? attributes.country : "AU";
        let p = parsePhoneNumber(value, countryCode);
        if (!p?.isPossible()) {
            return options.message || "Please enter a valid phone number";
        }
        return;
    } catch(err) {
        return options.message || "Please enter a valid phone number";
    }
};

validate.validators.isFile = function(value, options, key, attributes) {
    let t = typeof value?.name;
    if (t !== "string") {
        return options.message || "Please upload a file";
    }
    return;
}

validate.validators.isMobileNumber = function(value, options, key, attributes) {
    if(!value || value.length < 2) {
        return options.message || "Please enter a valid mobile number";
    }
    try {
        let countryCode = attributes.country ? attributes.country : "AU";
        let p = parsePhoneNumber(value, countryCode);
        if (!p?.isPossible()) {
            return options.message || "Please enter a valid mobile number";
        } else if (p?.getType() !== "MOBILE") {
            return options.message || "Please enter a valid mobile number";
        }
        return;
    } catch(err) {
        return options.message || "Please enter a valid phone number";
    }
};

const defaultSchema = {
    firstName: {
        presence: {
            message: "Please enter your name",
            allowEmpty: false
        }
    },
    lastName: {
        presence: {
            message: "Please enter your name",
            allowEmpty: false
        }
    },
    emailAddress: {
        presence: {
            message: "Email address is required",
            allowEmpty: false
        },
        email: {message: "Please enter a valid email address"}
    },
    mobilePhone: {
        dealerContactRequired: {
            message: "Mobile number is required"
        },
        format: {
            pattern: /^04.*$/,
            message: "Please enter a valid mobile number"
        }
    },
    phoneNumber: {
        presence: {
            message: "Phone number is required",
            allowEmpty: false
        },
        isPhoneNumber: {message: "Please enter a valid phone number"}
    },
    postCode: {
        presence: {
            message: "Please enter a postcode",
            allowEmpty: false
        },
        format: {
            pattern: /^\d{4}$/,
            message: "Please enter a valid postcode"
        }
    },
    postcode: {
        presence: {
            message: "Please enter a postcode",
            allowEmpty: false
        },
        format: {
            pattern: /^\d{4}$/,
            message: "Please enter a valid postcode"
        }
    },
    dealerName: {
        dealerContactRequired: {
            message: "Please select a dealer"
        }
    },
    modelId: {
        presence: {
            message: "Please select a model",
            allowEmpty: false
        }
    },
    variantId: {
        presence: {
            message: "Please select a variant",
            allowEmpty: false
        }
    },
    vin: {
        presence: {
            message: "Please enter your VIN",
            allowEmpty: false
        },
        isVin: {
            message: "Please enter a valid VIN"
        }
    },
    currentModel: {
        presence: {
            message: "Please make a selection",
            allowEmpty: false
        }
    },
    preferredContactMethod: {
        presence: {
            message: "Please make a selection",
            allowEmpty: false
        }
    },
    planningToBuyCar: {
        presence: {
            message: "Please make a selection",
            allowEmpty: false
        }
    },
    tradeKms: {
        tradeinRequired: {
            message: "This field is required"
        }
    },
    tradeHasFinance: {
        tradeinRequired: {
            message: "This field is required"
        }
    }
}

const validateForm = (values) => {
    var schema = {};
    var fields = Object.keys(values);
    for (let i=0; i<fields.length; i++) {
        let f = fields[i];
        if (typeof defaultSchema[f] !== 'undefined') {
            schema[f] = defaultSchema[f]
        }
    }
    var errors = validate(values, schema, {format: "firstError", fullMessages: false});
    return errors;
}

const getValidateForm = (customSchema) => {
    // combine custom schema with defaults
    const combinedSchema = Object.assign({}, defaultSchema, customSchema);
    // return validate function
    function fn(values) {
        var schema = {};
        var fields = Object.keys(values);
        for (let i=0; i<fields.length; i++) {
            let f = fields[i];
            if (typeof combinedSchema[f] !== 'undefined') {
                schema[f] = combinedSchema[f];
            }
        }
        var errors = validate(values, schema, {format: "firstError", fullMessages: false});
        return errors;
    };
    return fn;
}

export {
    validate,
    validateForm,
    getValidateForm,
    defaultSchema
};
